import React, { useState } from 'react'
import Modal from 'react-modal'
import { useStateValue } from '../../StateProvider';
import { getDefaultName, getDefaultValue, getUser, setUserSession } from '../../utils';
import { deleteCourseParticipant, doLogin } from '../../utils/Network';

function ModalUnroll({ course, courseTitle, courseParticipant, onSuccess, isOpen = false, setIsOpen }) {
    const [loading, setLoading] = useState(null)
    const [error, setError] = useState(null)
    const [modal_password, setModalPassword] = useState("");

    const CurrentUser = getUser()

    const [{ translations }] = useStateValue();
    const translate = (str) => {
        if (!translations) return str;
        var translate = translations.find(x => x.key === str);

        if (translate) return getDefaultValue(translate);
        else return "#" + str;
    };

    const resetModalState = () => {
        setModalPassword("");
        setError(null);
        setLoading(null);
    };

    const closeModal = () => {
        if (setIsOpen) setIsOpen(false);
    };

    const handleModalOnChange = (e) => {
        switch (e.target.name) {
            case "modal_password":
                setError(false)
                setLoading(false)
                setModalPassword(e.target.value)
                break;
            default:
                break;
        }
    }

    const completeUnroll = () => {
        closeModal()
        if (onSuccess) onSuccess()
    }

    const unRoll = () => {
        setError(false)
        if (loading) return;

        if (modal_password.length < 6) {
            setError(translate("Please enter your password"))
            setLoading(false)
            return;
        }
        setLoading(true)
        doLogin({ email: CurrentUser.email, password: modal_password }).then(data => {
            if (data.tokens) {
                setUserSession(data.tokens.access, data);

                if (courseParticipant) {
                    deleteCourseParticipant(courseParticipant?.id).then(completeUnroll).catch((err) => {
                        // A missing participant means the desired unrolled state is already reached.
                        // Some deployed DELETE responses can also lose their connection after committing.
                        if (err?.status === 404 || err instanceof TypeError) {
                            completeUnroll()
                            return
                        }
                        setError(err?.message || translate("Unable to unroll. Please try again."))
                        setLoading(false)
                    })
                } else {
                    setError(translate("Unable to unroll. Please try again."))
                    setLoading(false)
                }
            }
            else {
                setError(data.detail || translate("Incorrect password"));
                setLoading(false)
            }
        }).catch(() => {
            setError(translate("Unable to verify your password. Please try again."))
            setLoading(false)
        });
    }

    return (
        <Modal
            closeTimeoutMS={500}
            ariaHideApp={false}
            isOpen={Boolean(isOpen)}
            onRequestClose={closeModal}
            onAfterClose={resetModalState}
            className="Modal"
            overlayClassName="Overlay"
        >
            <div className="modal-content bg-upload-material unroll-modal">
                <div className="modal-header modal-header--polished no-border ">
                    <h2 className="modal-title-polished lan-text-right" id="defaultModalLabel">
                        {translate("Unroll from")}{" "}
                        {courseTitle
                            || (course && typeof course === 'object' && course.names
                                ? getDefaultName(course.names)
                                : '')}
                    </h2>
                    <button
                        type="button"
                        className="close modal-close-ghost"
                        onClick={closeModal}
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>
                <div className="modal-body lan-text-right unroll-modal__body">
                    <div className="unroll-modal__intro">
                        <span className="unroll-modal__intro-icon" aria-hidden="true">
                            <i className="fas fa-user-minus" />
                        </span>
                        <div>
                            <strong>{translate("Confirm unroll")}</strong>
                            <p>
                        {translate("to confirm , Please enter your password")}
                            </p>
                        </div>
                    </div>
                    <div className="unroll-modal__form">
                        <div className="unroll-modal__password">
                            <div className="input-group unroll-modal__input-group">
                                <div className="input-group-prepend ">
                                    <span
                                        className="input-group-text lan-border-radius-r"
                                        id="inputGroup-sizing-default"
                                    >
                                        <i className="fa fa-lock"></i>
                                    </span>
                                </div>
                                <input
                                    type="password"
                                    name="modal_password"
                                    value={modal_password}
                                    onChange={handleModalOnChange}
                                    placeholder="Password"
                                    className="form-control lan-ltr border-radius-25 lan-border-radius-l text-3 h-auto py-2"
                                />
                            </div>
                        </div>
                        <div className="unroll-modal__actions">
                            <button
                                type="button"
                                onClick={unRoll}
                                disabled={Boolean(loading)}
                                className="btn unroll-modal__submit kfont"
                            >
                                <i className={loading ? "fas fa-spinner fa-spin" : "fas fa-user-minus"} aria-hidden="true" />
                                {loading ? translate("Please wait...") : translate("Unroll")}
                            </button>
                        </div>
                    </div>
                    {error && (
                        <div className="unroll-modal__error" role="alert">
                            <i className="fas fa-exclamation-circle" aria-hidden="true" />
                            {error}
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    )
}

export default ModalUnroll
